import { ShowType } from '@ori/graphql-schema';
import { Team } from '@ori/testid-generator';
import * as queries from "../queries/client";

/**
 * User id for anonymous user.
 */
export var NOT_LOGGED_IN_USER_ID = -1;

/**
 * Name of this app.
 */
export var APP_NAME = 'personal-beauty-store';

/**
 * Name of this NPM package.
 */
export var PACKAGE_NAME = '@ori/personal-beauty-store';

/**
 * Team which owns this app.
 */
export var APP_TEAM_NAME = Team.Presentation;

/**
 * Desktop breakpoint
 */
export var DESKTOP_BREAKPOINT = 1024;

/**
/**
 * Default configuration values
 */
export var configurationContextDefaultValues = {
  currentLanguage: '',
  customerId: NOT_LOGGED_IN_USER_ID,
  graphqlUrl: '',
  globalApiUrl: '',
  identityUrl: '',
  staticApiUrl: '',
  tenant: '',
  isEnabled: false
};

/**
 * Default translation namespace
 */
export var DEFAULT_NAMESPACE = 'translation';

/**
 * Fallback language used for i18n
 */
export var DEFAULT_LANGUAGE = 'dev';
export var PERSONAL_BEAUTY_STORE_MOCKED_QUERY_DATA = {
  beautyStore: {
    profile: {
      firstName: 'John',
      lastName: 'Doe',
      name: null,
      photoUrl: null,
      contacts: null
    },
    productLists: [{
      productListId: '5ffd9fb8-c6a7-4b37-b9f8-e43b701bd125',
      items: [{
        itemCode: '1276'
      }]
    }],
    videoShows: [{
      showId: 'hixLgw2xhyxhegYKgQGh',
      isCurrent: true,
      startedAtUtc: '2022-11-29T17:08:45.097Z',
      endedAtUtc: '2022-11-29T18:08:45.097Z',
      typeOfShow: ShowType.Live
    }]
  },
  application: {
    personalProductListConfiguration: {
      isPplEnabled: true,
      addThis: {
        sharedUrl: 'https://cz-uat.oriflame.com/personal-products-list?store=1&personallist={personallist}'
      }
    },
    videoShopping: {
      configuration: {
        isVideoShoppingEnabled: true,
        addThis: {
          sharedUrl: 'https://cz-uat.oriflame.com/live-shopping?autoplayLiveShopping={liveShowId}&store={storeName}'
        }
      }
    }
  }
};
export var MOCKED_PBS_OWNER = '1';
export var MOCKED_PRODUCT_LIST_TYPE = 'Personal';
export var MOCKED_INVITE_FRIEND_CONSULTANT = 1;
export var INVITE_FRIEND_MOCKED_QUERY_DATA = {
  inviteFriendProfile: {
    firstName: 'Test',
    lastName: 'Testovic',
    photoUrl: null
  }
};
export var MOCKED_GRAPHQL_DATA = [{
  request: {
    query: queries.beautyStoreQuery,
    variables: {
      name: MOCKED_PBS_OWNER,
      productListType: MOCKED_PRODUCT_LIST_TYPE
    }
  },
  result: {
    data: PERSONAL_BEAUTY_STORE_MOCKED_QUERY_DATA
  }
}, {
  request: {
    query: queries.inviteFriendQuery,
    variables: {
      consultant: MOCKED_INVITE_FRIEND_CONSULTANT
    }
  },
  result: {
    data: INVITE_FRIEND_MOCKED_QUERY_DATA
  }
}];
export * from "./defaultTranslations";